var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlace = function SvgPlace(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.447,
    d: "M10 9.955a2 2 0 1 0 4 0v-.037a2 2 0 1 0-4 0m-4.873.127v-.172a6.873 6.873 0 1 1 13.746 0v.172c0 3.461-4.382 8.671-6.148 10.631a.973.973 0 0 1-1.45 0c-1.766-1.96-6.148-7.17-6.148-10.631Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlace);
export default ForwardRef;